import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { PendingVote } from '../../../core/models/mysec/corporate-action.model';
import {
  InterruptBody,
  InterruptHostRef,
} from '../../../core/services/post-login-interrupt/post-login-interrupt.model';

@Component({
  selector: 'app-pending-vote-modal',
  templateUrl: './pending-vote-modal.component.html',
  styleUrls: ['./pending-vote-modal.component.scss'],
  standalone: false,
})
export class PendingVoteModalComponent implements OnInit, InterruptBody {
  @Input() pendingVote: PendingVote;

  /**
   * INC-328 — set when this card is one page of the interrupt frame. `close()` and
   * `dismiss()` then resolve THIS ITEM instead of tearing the frame down. Absent when
   * the card is the modal, which is still the single-interrupt path.
   */
  @Input() host?: InterruptHostRef;

  /**
   * INC-328 — the frame draws the title and the close control, so this card must not
   * draw its own `.modal-header` on top of them.
   */
  @Input() hostOwnsChrome = false;

  daysLeft: number | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    if (this.pendingVote?.votingClosesAt) {
      const closesAt = new Date(this.pendingVote.votingClosesAt);
      const now = new Date();
      const diffMs = closesAt.getTime() - now.getTime();
      this.daysLeft = Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
    }
  }

  reviewAndVote(): void {
    if (this.host) {
      this.host.resolve();
    } else {
      this.activeModal.close();
    }
    this.router.navigate(['/pstx/corporate-action', this.pendingVote.corporateActionId]);
  }

  dismiss(): void {
    if (this.host) {
      this.host.defer();
      return;
    }
    this.activeModal.dismiss();
  }
}
